import { CloudOff } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

/** À la place d'une liste qui n'a pas pu être lue (panne, réseau).
 * Jamais « Aucun … » dans ce cas : le client croirait ses données perdues. */
export function ChargementImpossible({ darkMode }: { darkMode?: boolean }) {
  const { t } = useTranslation()
  return (
    <div className={cn('text-center py-12 px-6', darkMode ? 'text-slate-400' : 'text-gray-500')}>
      <CloudOff className="w-10 h-10 mx-auto mb-3 opacity-30" />
      <p className="text-sm">{t('chargementImpossible', 'Impossible de charger ces informations pour le moment.')}</p>
    </div>
  )
}
